const STORAGE_KEY = 'fu_driver_push_onboarded';

export function isPushOnboarded(): boolean {
  try {
    return localStorage.getItem(STORAGE_KEY) === '1';
  } catch {
    return false;
  }
}

export function markPushOnboarded(): void {
  try {
    localStorage.setItem(STORAGE_KEY, '1');
  } catch {
    // localStorage unavailable (private mode / quota); next submit will re-prompt.
  }
}

// Called from sign-out so the next driver on the same device sees a fresh
// push-permission prompt on their first duty-slip submit.
export function clearPushOnboarded(): void {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // localStorage unavailable; nothing to do.
  }
}

export function shouldShowPushPrompt(
  state: NotificationPermission | 'unsupported',
): boolean {
  if (state === 'unsupported' || state === 'granted' || state === 'denied') return false;
  return !isPushOnboarded();
}
